import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-speaking-score-meter',
  templateUrl: './speaking-score-meter.component.html',
  styleUrl: './speaking-score-meter.component.css'
})
export class SpeakingScoreMeterComponent implements OnInit {

  @Input() min: number = 0;
  @Input() mid: number;
  @Input() max: number;
  @Input() current: number;
  @Input() showPointer: boolean = true;

  rotationString: string;

  ngOnInit(): void {
    this.calculateNeedlePosition();
  }

  calculateNeedlePosition() {
    var rotationRangeStart, rotationRangeEnd, scoreRangeStart, scoreRangeEnd;
    
    if (this.current < this.mid) {
      rotationRangeStart = -90;
      rotationRangeEnd = 0;
      scoreRangeStart = this.min;
      scoreRangeEnd = this.mid;
    }
    else {
      rotationRangeStart = 0;
      rotationRangeEnd = 90;
      scoreRangeStart = this.mid;
      scoreRangeEnd = this.max;
    }

    var scoreRange = scoreRangeEnd - scoreRangeStart;
    var scoreInRange = this.current - scoreRangeStart;

    var rotationPercent = scoreInRange / scoreRange;
    var rotationRange = rotationRangeEnd - rotationRangeStart;
    var rotationInRange = rotationPercent * rotationRange;
    
    this.rotationString = Math.round(rotationRangeStart + rotationInRange) + "deg";
  }

}
